import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';

type NestedMenuItemProps = {
  to: string;
  primaryText: string;
  leftIcon: ReactNode;
  title?: string;
};

export const NestedMenuItem = ({
  to,
  primaryText,
  leftIcon,
  title: _title,
}: NestedMenuItemProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === to;

  const handleClick = () => {
    navigate(to);
  };

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={handleClick}
        selected={isActive}
        sx={{
          paddingLeft: '40px', // Indent nested items
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(25, 118, 210, 0.16)',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.24)',
            },
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 40,
            color: 'inherit',
            alignSelf: 'flex-start',
            marginTop: '4px', // Align with first line of text
          }}
        >
          {leftIcon}
        </ListItemIcon>
        <ListItemText
          primary={primaryText}
          sx={{
            '& .MuiListItemText-primary': {
              lineHeight: 1.5,
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
